import { locationIdFormat, productIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const adjustInventory = {
  name: "adjustInventory" as const,
  input: z.object({
    adjustments: z.array(
      z.object({
        productId: productIdFormat.schema,
        locationId: locationIdFormat.schema,
        quantity: z.number(),
        reason: z.string(),
      }),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
